// Enums
export const Auth = {
  AdminId: "admin-id",
  AccessToken: "access-token",
  RefreshToken: "refresh-token"
}

export function setCookie(key, value) {
  const config =
    process.env.NODE_ENV !== "local"
      ? ` domain=.scasset.com; secure; samesite=strict;`
      : '';
  const cookieKey = withEnv(key)

  document.cookie = `${cookieKey}=${value}; path=/;${config}`
}

export const getCookie = function (key) {
  const cookieKey = withEnv(key)
  const cookie = document.cookie.match(
    new RegExp(`${cookieKey}=([^\\;]*)`)
  )
  console.log(cookie)

  return cookie ? cookie[1] : null
}

export const unsetCookie = function (key) {
  const config =
    process.env.NODE_ENV !== "local"
      ? ` domain=.scasset.com; secure; samesite=strict;`
      : ''
  const cookieKey = withEnv(key)

  // Remove Cookie env
  document.cookie = `${cookieKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;${config}`
};

function withEnv(key) {
  const env = process.env.NODE_ENV

  const isNonProd = env !== "production"
  const isSelectedKey = key === Auth.AccessToken || key === Auth.RefreshToken

  return isNonProd && isSelectedKey ? `${env}~${key}` : key
}



// WEBPACK FOOTER //
// ./src/lib/cookie.js